import React from "react";
import "./loaderstyle.scoped.css";

function CustomLoader() {
  return (
    <div className="lds-default">
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
      <div />
    </div>
  );
}

export default CustomLoader;
